module.exports = __webpack_public_path__ + "img/sevice@2x.7288dd46.png";